import React from 'react';

import styles from './XKanbanColumn.module.scss';
import {} from "../../Utilities/Utilities";
import { XComponent } from '../commons/XComponent';
import { IComponentState } from '../commons/IComponentState';
import { IComponentProps } from '../commons/IComponentProps';
//import { EKanbanTicketType, ETheme } from '../enums';
import { XKanbanTicket } from './XKanbanTicket';
import { ETheme } from '../../types/enums/ETheme';
import { EKanbanTicketType } from '../../types/enums';

export interface IKanbanColumnProps extends IComponentProps {
    children? : React.ReactNode;
    header? : string | undefined;
    theme?: ETheme;
}

export interface IKanbanColumnState extends IComponentState {
    theme: ETheme;
}

export class XKanbanColumn extends XComponent<HTMLDivElement, IKanbanColumnProps, IKanbanColumnState> {
    public render(): React.ReactNode {
        return <div className={styles.XKanbanColumn}>
            <XKanbanTicket type={EKanbanTicketType.New}></XKanbanTicket>
            <XKanbanTicket type={EKanbanTicketType.New}></XKanbanTicket>
        </div>;
    }
}